import React from 'react';
import { useParams } from 'react-router-dom';

import AdminFormPage from 'components/admin/shared/AdminFormPage';
import Button from 'components/shared/Button';
import ButtonGroup from 'components/shared/ButtonGroup';
import CircularProgress from 'components/shared/CircularProgress';
import FormHeader from 'components/shared/form/FormHeader';
import { MultiSelectChips } from 'components/shared/form/InfiniteScrollDropdown';
import InputGroup from 'components/shared/form/InputGroup';
import { useAdminForm } from 'hooks/datasource';
import useInfiniteOptions from 'hooks/useInfiniteOptions';
import { adminIndexClients } from 'services/api/admin/clients';
import { adminFlagsQueryKeys, adminShowFlag, adminUpdateFlag } from 'services/api/admin/flags';

const getId = (o: any) => o!.id as string;
const getName = (o: any) => o!.name as string;

export default function EditFeatureFlag() {
  const { name } = useParams<{ name: string }>();

  const { values, dirty, setValue, submit, loading, goBack } = useAdminForm({
    id: name,
    show: adminShowFlag,
    create: async () => {},
    update: async (updateId: string, payload: any) => {
      return adminUpdateFlag(updateId, { name: updateId, clientIds: payload.clientIds });
    },
    include: [] as const,
    queryKey: adminFlagsQueryKeys,
    onUpdateSuccess: { toast: 'Feature flag successfully updated', navigate: '/admin/feature-flags' },
    onError: { toast: 'Something went wrong. Please try again.' },
    toFormValues: (data) => ({
      title: data?.title ?? '',
      clients: data?.clients ?? [],
    }),
    toPayload: (v) => ({
      clientIds: v.clients.map((c) => c.id),
    }),
  });

  const clientOpts = useInfiniteOptions({
    queryKey: ['adminClients', 'featureFlags'],
    fetchFn: adminIndexClients,
    params: { sortBy: 'name asc' },
  });

  if (loading) return <CircularProgress />;

  return (
    <AdminFormPage>
      <FormHeader title='Edit Feature Flag' subtitle={values?.title} />

      <InputGroup title={`Clients - ${values?.clients?.length ?? 0} selected`}>
        <MultiSelectChips
          title='Clients'
          {...clientOpts}
          values={values?.clients ?? []}
          onChange={(v) => setValue('clients', v)}
          getOptionValue={getId}
          getOptionLabel={getName}
          placeholder='Select...'
        />
      </InputGroup>

      <ButtonGroup style={{ justifyContent: 'flex-end' }}>
        <Button variant='ghost' onClick={goBack}>
          Cancel
        </Button>
        <Button onClick={submit} disabled={!dirty}>
          Update
        </Button>
      </ButtonGroup>
    </AdminFormPage>
  );
}
